import { USER_LOGOUT } from "../actions/types";

export default (response = null, action) => {
  if (action.type === USER_LOGOUT) {
    return action.payload;
  }
  return response;
};
